import { render } from "./InformationFooter.vue?vue&type=template&id=67631658&scoped=true&ts=true"
import script from "./InformationFooter.vue?vue&type=script&lang=ts"
export * from "./InformationFooter.vue?vue&type=script&lang=ts"

import "./InformationFooter.vue?vue&type=style&index=0&id=67631658&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67631658"]])

export default __exports__